@if (isCurrentTabBlocked()) {
	<app-blocked-view />
} @else {
	<router-outlet />
}
